// モーダルのスクロールバー
export const initModalBar = () => {
	document.querySelectorAll(".js-modal").forEach((modal) => {
		const inner = modal.querySelector(".js-modal-inner");
		if (!inner) return;

		const bar = document.createElement("span");
		bar.className = "modal-bar";
		bar.setAttribute("aria-hidden", "true");
		modal.appendChild(bar);

		const update = () => {
			const { scrollTop, scrollHeight, clientHeight } = inner;
			if (scrollHeight <= clientHeight + 1) {
				bar.style.display = "none";
				return;
			}
			const track = clientHeight - 16;
			const height = Math.max(40, (clientHeight / scrollHeight) * track);
			const top = 8 + (scrollTop / (scrollHeight - clientHeight)) * (track - height);
			bar.style.display = "block";
			bar.style.height = `${height}px`;
			bar.style.top = `${top}px`;
		};

		inner.addEventListener("scroll", update, { passive: true });
		window.addEventListener("resize", update);
		new MutationObserver(update).observe(modal, { attributes: true, attributeFilter: ["class"] });
		update();
	});
};

export default initModalBar;
